import React from 'react';

const Marquee = ({ text, className = '', speed = '20s' }) => (
  <div className={`overflow-hidden whitespace-nowrap flex items-center ${className}`}>
    <div className="animate-marquee inline-block" style={{ animationDuration: speed }}>
      <span className="mx-4">{text}</span>
      <span className="mx-4">{text}</span>
      <span className="mx-4">{text}</span>
      <span className="mx-4">{text}</span>
    </div>
    <div className="animate-marquee inline-block" style={{ animationDuration: speed }}>
      <span className="mx-4">{text}</span>
      <span className="mx-4">{text}</span>
      <span className="mx-4">{text}</span>
      <span className="mx-4">{text}</span>
    </div>
  </div>
);

export default Marquee;
